import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LayoutService } from './service/layout.service';
import { MaintenanceService } from './service/maintenance.service';
import { ConfirmDialogComponent } from '../shared/confirmDialog.component';
import { MaintenanceMessageDetails } from './model/MaintenanceMessageDetails';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

@Component({
    templateUrl: './maintenance.component.html',
    styleUrls: ['maintenance.scss'],
    standalone: false
})
export class MaintenanceFormComponent implements OnInit {
    loading = false;
    data;
    textArea;
    updatedMessage;

    @ViewChild('textbox', { static: false}) textAreaRef: ElementRef<HTMLTextAreaElement>;

    model: MaintenanceMessageDetails = {
        messageTitle: '',
        messageBody: '',
        messageActive: false,
        showLogin: false,
        linkText: '',
        hyperlink: '',
        messageWithLink: '',
        isMessageWithLink: false
    };

    constructor(
        public layout: LayoutService,
        public service: MaintenanceService,
        public dialog: MatDialog
    ) {
    }

    ngOnInit() {
        this.getMessage();
    }

    getMessage() {
        this.service.getCurrentMessage().subscribe((message: any) => {
            console.table(message.value);
            this.data = true;
            const { messageTitle, messageBody,
                showLogin, messageActive, linkText, hyperlink, messageWithLink, isMessageWithLink } = message.value;
            this.model.messageTitle = messageTitle;
            this.model.messageBody = messageBody;
            this.model.showLogin = showLogin;
            this.model.messageActive = messageActive;
            this.model.linkText = linkText;
            this.model.hyperlink = hyperlink;
            this.model.messageWithLink = messageWithLink;
            this.model.isMessageWithLink = isMessageWithLink;

            if(this.model.linkText && this.model.hyperlink)
                this.model.messageBody = this.model.messageBody.replace(/<a [^>]*>(.*?)<\/a>/g, this.model.linkText);
        }, error => {
            this.data = false;
            console.error(error);
        });
    }


    save(maintenanceForm: NgForm) {
        this.loading = true;
        if (maintenanceForm.value.showLogin === null) {
            maintenanceForm.value.showLogin = false;
        }

        if(!maintenanceForm.value.isMessageWithLink)
            maintenanceForm.value.messageWithLink = '';
        
        this.service.saveCurrentMessage(maintenanceForm.value)
            .subscribe(() => {
                this.loading = false;
                this.dialog.open(ConfirmDialogComponent, {
                    data: {
                        allowCancel: false,
                        title: 'Data Saved',
                        message: `The message has been saved correctly.`,
                        confirmText: 'Done'
                    }
                });
            }, () => {
                this.loading = false;
            });
    }

    clear(maintenanceForm: NgForm) {
        this.data = false;
        maintenanceForm.reset();
    }


    userAcceptsResponsibility(maintenanceForm: NgForm) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Confirm submission',
                message: `Are you sure you want to update this message, any previously saved
                    data will be overwritten ?`
            }
        });
        dialogRef.afterClosed().subscribe((userAcceptResponsibility) => {
            if (userAcceptResponsibility) {
                // this.model.messageActive = false;
                this.save(maintenanceForm);
                this.data = true;
            } else {
                this.data = false;
            }
        });
    }

    onTextSelect(): void {
        this.textArea = this.textAreaRef.nativeElement;
        this.model.linkText = this.textArea.value.substring(this.textArea.selectionStart, this.textArea.selectionEnd);
        if(this.model.isMessageWithLink)
        this.getMessageWithLink();
    }

    getAnnotatedMessage(): string {
        if(this.model.isMessageWithLink) {
            let message;
            if(this.model.messageBody) message = this.model.messageBody; else return;

            let selectionStartIndex, selectionEndIndex;
            if(this.textArea && this.textArea.selectionStart && this.textArea.selectionEnd){
                message = this.textArea.value;
                selectionStartIndex = this.textArea.selectionStart;
                selectionEndIndex = this.textArea.selectionEnd;
            } else {
                selectionStartIndex = this.messageBody.indexOf(this.model.linkText);
                selectionEndIndex = this.messageBody.indexOf(this.model.linkText)+this.model.linkText?.length;
            }
            return message.slice(0, selectionStartIndex) + '<'+ message.slice(selectionStartIndex , selectionEndIndex) + '>{' + this.model.hyperlink + '} ' + message.slice(selectionEndIndex);
        } else {
            let message;
            if(this.model.messageBody) message = this.model.messageBody; else return;
            return message;
        }
    }

    getMessageWithLink() {
    
        let message = this.getAnnotatedMessage();
        if(!message) return

        let updatedMessage;
        
        let linkFirstIndex = message.indexOf('{');
        let linkLastIndex = message.indexOf('}');
        let hyperLink = message.slice(linkFirstIndex+1, linkLastIndex);

        updatedMessage = message.replace('{'+hyperLink+'}','');
        
        let linkTextFirstIndex = message.indexOf('<');
        let linkTextLastIndex = message.indexOf('>');
        let linkText = message.slice(linkTextFirstIndex+1, linkTextLastIndex);

        let anchorTag = '<a href="'+hyperLink+'" target="_blank">'+linkText+'</a>';

        updatedMessage = updatedMessage.replace('<'+linkText+'>',anchorTag);

        this.model.messageWithLink = updatedMessage;
        
        return(updatedMessage);
    }

    onAddingHyperLink() {
        this.getMessageWithLink();
    }

    onBlurTextArea(){
        if(this.textArea && !this.textArea.value) {
            this.model.linkText = '';
            // this.linkInTheMessage = '';
        }
    }

    get bannerMessage() {
        return (this.model && this.model.hyperlink && this.model.isMessageWithLink) ? this.model.messageWithLink : this.model.messageBody;
    }

    get messageBody() {
        return (this.model.isMessageWithLink) ? this.model.messageWithLink : this.model.messageBody;
    }

    get isLinkTextSelected() {
        return this.model.linkText && this.model.messageBody.indexOf(this.model.linkText) >= 0;
    }

}
